const seeAnyoneReasonGroup = $('#reason-not-happy-group');
const mobileGroup          = $('#mobile-group');

function toggleSeeAnyoneReasonGroup() {
    if ($('#happy-no').prop('checked')) {
        seeAnyoneReasonGroup.slideDown();
    } else {
        seeAnyoneReasonGroup.slideUp();
    }
}

function toggleMobileGroup() {
    if ($('#telephone-consent-no').prop('checked')) {
        mobileGroup.slideUp();
    } else {
        mobileGroup.slideDown();
    }
}

$('#happy-yes, #happy-no').on('change', toggleSeeAnyoneReasonGroup);
$('#telephone-consent-yes, #telephone-consent-no').on('change', toggleMobileGroup);

if ($('#happy-yes').prop('checked')) {
    seeAnyoneReasonGroup.slideUp();
}
